module.exports = __webpack_public_path__ + "static/media/washington-dc-18.672b78cc.jpg";